import { render, staticRenderFns } from "./TotalBackgroundSettings.vue?vue&type=template&id=2c2d6550"
import script from "./TotalBackgroundSettings.vue?vue&type=script&lang=js"
export * from "./TotalBackgroundSettings.vue?vue&type=script&lang=js"
import style0 from "./TotalBackgroundSettings.vue?vue&type=style&index=0&id=2c2d6550&prod&lang=scss&scopd=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports